import { Component } from '@angular/core';

import { APP_NAME, APP_VERSION } from '../../constants/app.constants';

@Component({
  selector: 'idap-footer',
  standalone: true,
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  protected readonly appName = APP_NAME;
  protected readonly appVersion = APP_VERSION;
  protected readonly currentYear = new Date().getFullYear();
}
